import AccountDetailsPage from '@/components/Account/AccountDetails/AccountDetails'
import CardsContainer from '@/components/Account/CardsContainer/CardsContainer'
import OrderHistoryPage from '@/components/Account/OrderHistory/OrderHistory'
import ReferralsPage from '@/components/Account/Referrals/Referrals'
import SubscriptionsPage from '@/components/Account/Subscriptions/Subscriptions'
import LoginAccountForm from '@/components/Forms/LoginAccountForm'
import { useCustomerContext } from '@/context/CustomerContext'
import { useMemberAccountContext } from '@/context/MemberAccountContext'
import { useRouter } from 'next/router'
import classes from './AccountMainPage.module.scss'
import { useState } from 'react'
import { useDeepCompareEffectNoCheck } from 'use-deep-compare-effect'
import { getAccountSettings } from '@/utils/getAccountSettings'
import getCollectionListProducts from '@/utils/getCollectionListProducts'
import { getProductsByHandles } from '@/utils/getProducts'
import { getRecentArticlesHandles } from '@/utils/getRecentArticleHandles'

const AccountTab = ({ tab, accountSettings }) => {
  const router = useRouter()
  const { customer } = useCustomerContext()
  const { reloadingData, subsData } = useMemberAccountContext()
  const [selectedTab, setSelectedTab] = useState(tab)

  useDeepCompareEffectNoCheck(() => {
    setSelectedTab(router.query.tab)
  }, [router.query.tab])

  const renderBody = (pickedTab) => {
    switch (pickedTab) {
      default:
      case 'subscriptions':
        return (
          <SubscriptionsPage
            subsData={subsData}
            accountSettings={accountSettings[selectedTab]}
          />
        )
      case 'account-details':
        return (
          <AccountDetailsPage subscriptions={subsData} customer={customer} />
        )
      case 'order-history':
        return <OrderHistoryPage customer={customer} />
      case 'referrals':
        return <ReferralsPage customer={customer} />
    }
  }

  const loginForm = (
    <div
      data-testid="login-form-wrapper"
      style={{ textAlign: 'center', marginTop: '100px', marginBottom: '100px' }}
    >
      <LoginAccountForm />
    </div>
  )

  const loadingDisplay = (
    <h4 data-testid="loading-display-text" className={classes['loading']}>
      Loading your information
    </h4>
  )

  return (
    <div className={`${classes['main']}`}>
      {!reloadingData && subsData ? (
        <div data-testid="account-main-page">
          {/* Cards */}
          <div className={classes['cards']}>
            <CardsContainer
              customer={customer}
              subscriptions={subsData}
            ></CardsContainer>
          </div>
          {/* Body Content */}
          <div>{renderBody(selectedTab)}</div>
        </div>
      ) : !!reloadingData || (!!customer && !subsData) ? (
        loadingDisplay
      ) : (
        loginForm
      )}
    </div>
  )
}

export async function getStaticPaths() {
  const paths = [
    { params: { tab: 'subscriptions' } },
    { params: { tab: 'account-details' } },
    { params: { tab: 'order-history' } },
    { params: { tab: 'referrals' } },
  ]

  return {
    paths,
    fallback: 'blocking',
  }
}

export async function getStaticProps({ params }) {
  const accountSettings = await getAccountSettings()

  //#region SUBSCRIPTIONS TAB
  if (accountSettings.subscriptions) {
    if (
      accountSettings.subscriptions.emptySubscriptionsContent?.some(
        (content) => content._type === 'featuredBlogContent',
      )
    ) {
      await getRecentArticlesHandles(page.fields.content)
    }

    const featuredSubscriptionBlock =
      accountSettings.subscriptions.emptySubscriptionsContent?.find(
        (content) => content._type === 'featuredSubscriptionBlock',
      )
    if (featuredSubscriptionBlock) {
      const productHandles = featuredSubscriptionBlock.subscriptionList
        ?.filter(({ babOverride, handle }) => !babOverride && handle)
        .map(({ handle }) => handle)

      if (productHandles) {
        const products = await getProductsByHandles({ productHandles })
        featuredSubscriptionBlock.subscriptionList =
          featuredSubscriptionBlock.subscriptionList.map((subscriptionItem) => {
            const productInfo = products.find(
              ({ handle }) => subscriptionItem.handle === handle,
            )
            if (productInfo) {
              return { ...subscriptionItem, productInfo }
            }

            return subscriptionItem
          })
      }
    }

    if (
      accountSettings.subscriptions.emptySubscriptionsContent?.some(
        (content) => content._type === 'collectionList',
      )
    ) {
      await getCollectionListProducts(page)
    }
  }
  //#endregion

  return {
    props: {
      tab: params.tab,
      accountSettings: accountSettings,
    },
  }
}

export default AccountTab
